import React from 'react'
import { Box } from '@mui/material'
import { Header } from '..'
import CustomMenuLink from './CustomMenuLink'
import CustomMenuDropdown from './CustomMenuDropdown'
import CustomMenuDrawer from './CustomMenuDrawer'
import CustomMenuModal from './CustomMenuModal'

/**
 * HeaderCustomMenuItem component that renders different types of menu items based on the menuType property.
 *
 * @param {Object} props - The component props
 * @param {Object} props.menuItem - Configuration for the menu item
 * @param {string} props.menuItem.menuType - Type of menu: 'link', 'dropdown', 'drawer', or 'modal'
 * @param {Object} props.menuItem.trigger - Configuration for the trigger element
 * @param {string} props.menuItem.trigger.type - Type of trigger: 'text', 'image', 'base64', 'svg'
 * @param {string} props.menuItem.trigger.value - Content of the trigger element
 * @param {Object} props.menuItem.trigger.style - Style object for the trigger
 * @param {Array|Object|string} props.menuItem.content - Content configuration
 * @param {string} props.menuItem.url - URL for link type menu items
 * @param {Object} props.menuItem.drawerOptions - Options for drawer type menu items
 * @param {Object} props.menuItem.modalOptions - Options for modal type menu items
 * @param {Object} props.style - Style object for the container
 */
const HeaderCustomMenuItem = ({ menuItem, style }) => {
    if (!menuItem) return null

    const renderMenuItem = () => {
        switch (menuItem.menuType) {
            case 'link':
                return <CustomMenuLink menuItem={menuItem} />
            case 'dropdown':
                return <CustomMenuDropdown menuItem={menuItem} />
            case 'drawer':
                return <CustomMenuDrawer menuItem={menuItem} />
            case 'modal':
                return <CustomMenuModal menuItem={menuItem} />
            default:
                return null
        }
    }

    return (
        <Header.Item style={{ ...style }}>
            <Box display="flex" alignItems="center" height="100%">
                {renderMenuItem()}
            </Box>
        </Header.Item>
    )
}

export default HeaderCustomMenuItem
